module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"googleAds":"Google Ads"},"fr":{"googleAds":"Google Ads"},"de":{"googleAds":"Google Ads"}}')
  delete Component.options._Ctor
}
